import { AuthDataContext } from "./context";
import { useContext } from "react";

export function useAuthDataHook() {
  return useContext(AuthDataContext);
}
